<template>
  <div class="footer">
    <div class="f-one">
      <div class="xian"></div>
      Health Force•医疗健康驱动引擎
      <div class="xian xr"></div>
    </div>
    <div class="f-two">
      Copyright© 2020-{{ new Date().getFullYear() }} 深圳市新保云信息技术有限公司 All Rights Reserved.
      <a target="_black" href="https://icp.chinaz.com/?type=num&s=%E7%B2%A4ICP%E5%A4%872021085612%E5%8F%B7&hidesel=%E5%A4%87%E6%A1%88%E7%BC%96%E5%8F%B7"
        >粤ICP备2021085612号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalFooter",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.footer {
  margin-top: 20px;
  width: 100%;
  text-align: center;
  color: #999999;
  font-size: 12px;
  flex-shrink: 0;
  flex-direction: column;
  display: flex;
  .f-one {
    justify-content: center;
    align-items: center;
    display: flex;
    color: #333;
    flex: 1;
    height: 36px;
    .xian {
      height: 2px;
      width: 100px;
      background: #333;
      margin-right: 6px;
    }
    .xian.xr {
      margin-left: 6px;
      margin-right: 0;
    }
  }
  .f-two {
    justify-content: center;
    align-items: center;
    display: flex;
    color: #333;
    height: 36px;
  }
}
</style>
